const skills = [
  { habilidade: "JavaScript" },
  { habilidade: "React" },
  { habilidade: "Python" },
  { habilidade: "Node.js" },
  { habilidade: "PHP" },
  { habilidade: "Java" },
  { habilidade: "MySql" },
  { habilidade: "Git" },
  { habilidade: "GitHub" },
  { habilidade: "Firebase"}
];

export default skills;
